export default __webpack_public_path__ + "static/media/1_example.c1bc8f0f.jpg";